import React from "react";
import logo from "../icon-android.png";

const Header = () => {
  return (
    <header className="app-header">
      <div className="container">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img src={logo} alt="MyQuest Logo" className="h-10 w-10 rounded-full" />
            <div>
              <h1 className="text-2xl font-bold tracking-tight">MyQuest Admin</h1>
              <p className="text-sm text-gray-600">Control center for the MyQuest team</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
